var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconManagerEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "42px",
    viewBox: "0 0 48 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-742.000000, -1529.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    transform: "translate(208.000000, 1473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(446.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(16.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paginate-filter-mail",
    transform: "translate(41.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,31.972 C46,33.6288542 44.6568542,34.972 43,34.972 L9,34.972 C7.34314575,34.972 6,33.6288542 6,31.972 L6,3.972 C6,2.31514575 7.34314575,0.972 9,0.972 L43,0.972 C44.6568542,0.972 46,2.31514575 46,3.972 L46,31.972 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "45 1.972 26 19.972 7 1.972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9.016 L2,9.016 C0.8954305,9.016 0,9.9114305 0,11.016 L0,39.016 C0,40.1205695 0.8954305,41.016 2,41.016 L36,41.016 C37.1045695,41.016 38,40.1205695 38,39.016 L38,35.016",
    id: "Path"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManagerEmail);
export default __webpack_public_path__ + "static/media/Icon_Manager_Email.b17c3f4dff6943758036cb49d83544f4.svg";
export { ForwardRef as ReactComponent };